<template>
    <b-form-group
        :label="label"
        :label-for="id"
    >
        <b-form-input
          :id="id"
          v-money="percentageFormat"
          :value="value"
          @input="handleInput"
          :class="{ 'is-invalid': thereIsError }"
          :disabled="disabled"
        />
        <div class="invalid-feedback">
          <span v-if="thereIsError">
            {{ errorMessage }}
          </span>
        </div>
    </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput
} from 'bootstrap-vue'
import { VMoney } from 'v-money'
import { getVueSelectErrorClass } from '@/helpers/validators'
import { getPercentageFormat } from '@/helpers/formatting'
export default {
  components: {
    BFormGroup,
    BFormInput
  },
  directives: {
    money: VMoney
  },
  props: {
    id: String,
    label: String,
    value: String,
    thereIsError: Boolean,
    errorMessage: String,
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      content: this.value
    }
  },
  computed: {
    percentageFormat: function () {
      return getPercentageFormat()
    },
  },
  methods: {
    handleInput (content) {
      this.$emit('input', content)
    }
  }
}
</script>
